import { render, staticRenderFns } from "./ParentFicheProjet.vue?vue&type=template&id=bfd1f738&"
import script from "./ParentFicheProjet.vue?vue&type=script&lang=js&"
export * from "./ParentFicheProjet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports